import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
type OS = 'mac' | 'windows' | 'other';
export const useOS = () => {
  const $ = _c(2);
  const [os, setOS] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const platform = navigator.platform.toLowerCase();
      const userAgent = navigator.userAgent.toLowerCase();
      if (platform.includes("mac") || userAgent.includes("mac")) {
        setOS("mac");
      } else {
        if (platform.includes("win") || userAgent.includes("win")) {
          setOS("windows");
        } else {
          setOS("other");
        }
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return os;
};
export default useOS;